import {
  FETCH_SINGLE_USER_PROFILE_START,
  FETCH_SINGLE_USER_PROFILE_SUCCESS,
  FETCH_SINGLE_USER_PROFILE_FAILURE,
  FETCH_SINGLE_USER_POSTS_START,
  FETCH_SINGLE_USER_POSTS_SUCCESS,
  FETCH_SINGLE_USER_POSTS_FAILURE,
  SET_OTHER_USER_SINGLE_POST,
  UPDATE_FOLLOW_STATUS,
  SEARCH_USER_POST_START,
  SEARCH_USER_POST_SUCCESS,
  SEARCH_USER_POST_FAILURE,
  UPDATE_OTHERS_USER_POST_LIKE,
  UPDATE_OTHER_USER_POST_COMMENTS,
  UPDATE_OTHER_USER_POST_COMMENTS_COUNT,
  UPDATE_OTHER_USER_POST_BOOKMARK_STATUS,
  FETCH_SINGLE_USER_PUBLIC_PROFILE_START,
  FETCH_SINGLE_USER_PUBLIC_POSTS_START,
  FETCH_SINGLE_USER_CONTENT_START,
  FETCH_SINGLE_USER_PROFILE_RESET,
} from "./ActionConstant";

export function fetchSingleUserContentStart(data) {
  return {
    type: FETCH_SINGLE_USER_CONTENT_START,
    data,
  };
}

export function fetchSingleUserProfileStart(data) {
  return {
    type: FETCH_SINGLE_USER_PROFILE_START,
    data,
  };
}

export function fetchSingleUserPublicProfileStart(data) {
  return {
    type: FETCH_SINGLE_USER_PUBLIC_PROFILE_START,
    data,
  };
}

export function fetchSingleUserProfileSuccess(data) {
  return {
    type: FETCH_SINGLE_USER_PROFILE_SUCCESS,
    data,
  };
}

export function fetchSingleUserProfileFailure(error) {
  return {
    type: FETCH_SINGLE_USER_PROFILE_FAILURE,
    error,
  };
}  
export function fetchSingleUserprofileReset() {
  return {
    type: FETCH_SINGLE_USER_PROFILE_RESET
  }
}

export function setOtherUserSinglePost(data) {
  return {
    type: SET_OTHER_USER_SINGLE_POST,
    data,
  };
}

export function fetchSingleUserPostsStart(data) {
  return {
    type: FETCH_SINGLE_USER_POSTS_START,
    data,
  };
}

export function fetchSingleUserPublicPostsStart(data) {
  return {
    type: FETCH_SINGLE_USER_PUBLIC_POSTS_START,
    data,
  };
}

export function fetchSingleUserPostsSuccess(data) {
  return {
    type: FETCH_SINGLE_USER_POSTS_SUCCESS,
    data,
  };
}

export function fetchSingleUserPostsFailure(error) {
  return {
    type: FETCH_SINGLE_USER_POSTS_FAILURE,
    error,
  };
}

export function searchUserPostStart(data) {
  return {
    type: SEARCH_USER_POST_START,
    data,
  };
}

export function searchUserPostSuccess(data) {
  return {
    type: SEARCH_USER_POST_SUCCESS,
    data,
  };
}

export function searchUserPostFailure(error) {
  return {
    type: SEARCH_USER_POST_FAILURE,
    error,
  };
}

export function updateOtherUserPostLikes(data) {
  return {
    type: UPDATE_OTHERS_USER_POST_LIKE,
    data
  }
}

export function updateOtherUserPostCommentsCount(data) {
  return {
    type: UPDATE_OTHER_USER_POST_COMMENTS_COUNT,
    data,
  }
}

export function updateOtherUserPostBookmarkStatus(data) {
  return {
    type: UPDATE_OTHER_USER_POST_BOOKMARK_STATUS,
    data,
  }
}

export function updateOtherUserPostComments(data) {
  return {
    type: UPDATE_OTHER_USER_POST_COMMENTS,
    data,
  }
}

export function updateFollowStatus(data) {
  return {
    type: UPDATE_FOLLOW_STATUS,
    data,
  }
}
